const APPINSIGHTS_INSTRUMENTATIONKEY =
  import.meta.env.REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY ?? "";
const APPLICATIONINSIGHTS_CONNECTION_STRING =
  import.meta.env.REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING ?? "";

export const appInsightsConfig = {
  instrumentationKey: APPINSIGHTS_INSTRUMENTATIONKEY,
  connectionString: APPLICATIONINSIGHTS_CONNECTION_STRING,
};
